
/**
 * PLUGINS
 */
import initializeLodash from './plugins/lodash';

/**
 * COMPONENTS / MODULES
 */
import component from './TinyMCE.vue';

/**
 * SERVICES
 */
import './services/api';

/**
 * TINYMCE
 */
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/advlist/plugin.min';
import 'tinymce/plugins/image/plugin.min';
import 'tinymce/plugins/autolink/plugin.min';
import 'tinymce/plugins/link/plugin.min';
import 'tinymce/plugins/lists/plugin.min';
import 'tinymce/plugins/charmap/plugin.min';
import 'tinymce/plugins/searchreplace/plugin.min';
import 'tinymce/plugins/code/plugin.min';
import 'tinymce/plugins/table/plugin.min';
import 'tinymce/plugins/visualblocks/plugin.min';
import 'tinymce/plugins/contextmenu/plugin.min';
import 'tinymce/plugins/paste/plugin.min';
import 'tinymce/plugins/autoresize/plugin.min';
import 'tinymce/plugins/imagetools/plugin.min';

function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  initializeLodash(Vue);
  Vue.component('TinyMCE', component);
}

const plugin = {
  install,
};

let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

component.install = install;

export default component;